import logo from "../assets/logo.png";
import Image from "react-bootstrap/Image";
import { Row, Col } from "react-bootstrap";

export default function Footer() {
  return (
    <footer className="foot mt-5">
      <Row className="align-items-center g-4">
        <Col md={4} className="text-center text-md-start">
          <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-3">
            <Image
              src={logo}
              alt="Financials.hu"
              height="45"
              width="48"
              className="footer-logo"
            />
            <span
              className="fw-bold fs-5"
              style={{ color: "var(--title-color)", letterSpacing: "1px" }}
            >
              FINANCIALS.hu
            </span>
          </div>
          <p className="small mt-2 mb-0 opacity-75">
            Független vállalati pénzügyi szakértő.
          </p>
        </Col>

        <Col md={4} className="text-center">
          <div className="d-flex justify-content-center gap-3">
            <a href="/impresszum">Impresszum</a>
            <a href="/rolunk">Rólunk</a>
            <a href="/adatkezelesi-tajekoztato">Adatkezelés</a>
          </div>
        </Col>

        <Col md={4} className="text-center text-md-end">
          <p className="mb-0 small opacity-75">
            © {new Date().getFullYear()} – Minden jog fenntartva.
          </p>
        </Col>
      </Row>
    </footer>
  );
}
